
import { authHeader } from '../../_helpers';
import axios from 'axios';

export const addSellerAdminService = {
    addSellerAdmin
};

axios.defaults.headers.common = authHeader();

function addSellerAdmin(data) {
    return axios.post('/users/add/seller/admin/', data).then(response => {

        return response;
    });
}



// WEBPACK FOOTER //
// ./src/_services/sellers/addSellerAdmin.service.js